<template>
	<div>
		<div class="main">
			<div class="bx">（必选）请选择您的反馈类型</div>
			
			<div class="d-flex d-aic new-bx" style="flex-wrap: wrap;">
				<template v-for="(item,index) in type_list">
					<div class="d-flex d-aic new-bx-item showHand" @click="type_index = index">
						<img v-if="index!=type_index" class="bx-img" src="../../../assets/img/new/no-select.png" >
						<img v-else class="bx-img" src="../../../assets/img/new/select.png" >
						<div class="bx-text">{{item}}</div>
					</div>
				</template>
			</div>
			
			
			
			<ul>
				<textarea name="textarea" v-model="descVal" placeholder="在此输入反馈建议..."></textarea>
				<p>{{descNum}}/200</p>
			</ul>
			<button type="button" class="showHand" @click="throttle(addSubmit,3000)">提交</button>
		</div>
	</div>
</template>

<script>
	import { addAppCOpinion } from "@/api/feedbackIbfo.js"
	let _self;
	export default {
		name: "",
		data() {
			return {
				userInfo:null,
				//输入框中的内容
				descVal: "",
				//是否允许请求
				isrequest:true,
				// 必选类型
				type_list:['订单','商品','会员中心','其他'],
				type_index:-1,
				
				jmsId:this.$store.getters.getJmsId,
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// console.log("用户信息",_self.userInfo);
		},
		// 方法集
		methods: {
			addSubmit(){
				if(_self.type_index==-1){
					_self.$eror('请选择反馈类型')
					return false;
				}
				if(_self.descVal==''){
					_self.$eror('请输入意见反馈')
					return false;
				}
				if(!_self.isrequest) return;
				_self.isrequest=false;
				//新增接口
				addAppCOpinion({
					opinionTrader:_self.jmsId,
					opinionType:(_self.type_index+1),
					opinionContent:_self.descVal,
					opinionUserId:_self.userInfo.userId,
				}).then(res=>{
					// console.log("意见反馈",res);
					if(res.code==200){
						// 提示提交成功
						_self.$message({
							message:'反馈提交成功',
							type:'success'
						})
						
						//清空输入框中的内容
						_self.descVal=''
					}
					// 允许再次请求
					_self.isrequest=true;
				})
			}
		},
		// 组件集
		components: {

		},
		mounted() {

		},
		watch: {

		},
		computed: {
			descNum() {
				if (_self.descVal.length >= 200) {
					_self.descVal = _self.descVal.substr(0, 200);
					return 200;
				}
				return _self.descVal.length == 0 ? 0 : _self.descVal.length;
			}
		},
		// 过滤器
		filters: {

		},
		// 实例销毁
		destroyed() {

		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			next();
		},
	}
</script>

<style scoped>
	.main {
		width: 100%;
		background-color: #FFFFFF;
		padding: 20px 60px 60px 60px;
		box-sizing: border-box;
		margin-bottom: 45px;
	}

	.main textarea {
		width: 890px;
		height: 360px;
		background: #f5f5f5;
		border-radius: 2px;
		font-size: 16px;
		font-weight: 400;
		color: #999999;
		letter-spacing: 1px;
		padding: 12px 16px;
		box-sizing: border-box;
		margin-bottom: 40px;
	}

	.main ul {
		position: relative;
	}

	p {
		position: absolute;
		right: 10px;
		top: 330px;
		font-size: 14px;
		font-weight: 400;
		color: #999999;
		letter-spacing: 1px;
	}

	button {
		width: 240px;
		height: 44px;
		background: #e62129;
		border-radius: 2px;
		font-size: 18px;
		font-weight: 400;
		text-align: center;
		color: #ffffff;
	}
	.new-bx{
		width: 300px;
	}
	.new-bx-item{
		width: 150px;
		margin-bottom: 20px;
	}
	.bx{
		font-size: 16px;
		font-weight: 400;
		color: #000000;
		letter-spacing: 2px;
		margin-bottom: 20px;
	}
	.bx-img{
		width: 24px;
		height: 24px;
	}
	.bx-text{
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		letter-spacing: 1px;
	}
</style>
